import ConnectStoreModal from './ConnectStoreModal'

export default ConnectStoreModal
